import _ from 'lodash'
import {useContext} from 'react'
import {Button} from 'semantic-ui-react'
import {goodBadLabelStyle} from '@/utils/colors'
import {AuthContext} from '@/features/auth'
import {ILabelingWidgetConfig, ILabelingWidgetProps} from '..'

export interface IScoreLabel {
  score: number
}

export interface IDefaultLabelingWidgetProps extends ILabelingWidgetProps<IScoreLabel> {
  compact?: boolean
  showValue?: boolean
}

function computeLabelStyle(data: IScoreLabel) {
  if (data.score === undefined) return
  return goodBadLabelStyle(data.score / 5)
}

function LabelingWidget(props: IDefaultLabelingWidgetProps) {
  const {
    currentLabelData,
    disabled,
    compact,
    showValue,
    implicitLabelData,
    setCurrentLabelData,
    deleteLabelData,
  } = props

  const {havePermission} = useContext(AuthContext)

  const canAddLabel = havePermission('label.add_label')

  if (compact)
    return (
      <Button.Group>
        <Button
          compact
          size='tiny'
          icon='thumbs down'
          disabled={disabled || !canAddLabel}
          color={_.isEqual(currentLabelData?.score, 0) ? 'red' : 'grey'}
          onClick={(e) => {
            e.stopPropagation()
            if (_.isEqual(currentLabelData?.score, 0)) return deleteLabelData()
            setCurrentLabelData({score: 0})
          }}
          onFocus={(e: any) => e.target.blur()}
        />
        {showValue ?
          <Button
            compact
            disabled
            secondary
            size='tiny'
            content={currentLabelData?.score === undefined ? '-' : currentLabelData.score}
          />
        : null}
        <Button
          compact
          size='tiny'
          icon='thumbs up'
          disabled={disabled || !canAddLabel}
          color={_.isEqual(currentLabelData?.score, 5) ? 'green' : 'grey'}
          onClick={(e) => {
            e.stopPropagation()
            if (_.isEqual(currentLabelData?.score, 5)) return deleteLabelData()
            setCurrentLabelData({score: 5})
          }}
          onFocus={(e: any) => e.target.blur()}
        />
      </Button.Group>
    )

  return (
    <div>
      <Button.Group>
        {_.map(_.range(0, 6), (v) => {
          return (
            <Button
              key={v}
              content={v}
              disabled={disabled || !canAddLabel}
              color={_.isEqual(currentLabelData?.score, v) ? undefined : 'grey'}
              onClick={(e) => {
                e.stopPropagation()
                setCurrentLabelData({score: v})
              }}
              onFocus={(e: any) => e.target.blur()}
            />
          )
        })}
      </Button.Group>
      {implicitLabelData && !_.isEqual(implicitLabelData.score, currentLabelData?.score) ?
        <div style={{textAlign: 'center'}}>(implicit label: {implicitLabelData.score})</div>
      : null}
    </div>
  )
}

export const labelingWidgetConfigDefault: ILabelingWidgetConfig<
  IScoreLabel,
  IDefaultLabelingWidgetProps
> = {
  canDelete: true,
  control: LabelingWidget,
  computeLabelStyle,
}
